module.exports = __webpack_public_path__ + "assets/events_transportation_white.c420943e.svg";